import React from 'react';
import { Chip } from '@mui/material';

export interface EntitlementStatusBadgeProps {
  status: 'Active' | 'Trial' | 'Suspended' | 'Expired' | string;
  size?: 'small' | 'medium';
}

const statusConfig: Record<string, { color: 'success' | 'info' | 'warning' | 'default'; label: string }> = {
  Active: { color: 'success', label: 'Active' },
  Trial: { color: 'info', label: 'Trial' },
  Suspended: { color: 'warning', label: 'Suspended' },
  Expired: { color: 'default', label: 'Expired' },
};

export function EntitlementStatusBadge({ status, size = 'small' }: EntitlementStatusBadgeProps) {
  const config = statusConfig[status] || { color: 'default' as const, label: status || 'Unknown' };
  return <Chip label={config.label} color={config.color} size={size} />;
}
